/**
 * UI text for the SFG admin app, in Mongolian and English.
 *
 * Mongolian is the default and stays the reference wording. Add a key here, then read it with
 * the `t` function from useTranslation(). A missing key falls back to the Mongolian text, so a
 * partly translated screen still renders.
 */
const translations = {
    mn: {
        "lang.name": "Монгол",
        "lang.switch": "Хэл",

        // layout / sidebar
        "app.title": "STU Finance",
        "nav.transactionPlan": "Гүйлгээний төлөвлөгөө",
        "nav.transactionReceipt": "Гүйлгээний Баримт",
        "nav.transactionSchedule": "Гүйлгээний хуваарь",
        "nav.balance": "Баланс",
        "nav.statements": "Хуулга",
        "nav.institutions": "Байгууллагууд",
        "nav.rates": "Ханш",
        "nav.users": "Хэрэглэгчид",
        "nav.logout": "Системээс гарах",

        // shared actions
        "action.refresh": "Сэргээх",
        "action.add": "Мэдээлэл нэмэх",
        "action.save": "Хадгалах",
        "action.clear": "Цэвэрлэх",
        "action.close": "Хаах",
        "action.download": "Татах",
        "action.view": "Харах",
        "action.upload": "Нэхэмжлэл",
        "action.replace": "Солих",
        "action.preview": "Preview",
        "action.removeFile": "Файл арилгах",
        "action.retry": "Дахин оролдох",
        "action.edit": "Засах",
        "action.delete": "Устгах",
        "action.cancel": "Болих",

        // transaction plan page
        "plan.title": "Гүйлгээний төлөвлөгөө",
        "plan.stat.total": "Нийт төлөвлөгөө",
        "plan.stat.withInvoice": "Нэхэмжлэлтэй",
        "plan.stat.filtered": "Шүүлтээр олдсон",
        "plan.empty": "Гүйлгээний төлөвлөгөө олдсонгүй",
        "plan.loadError": "Мэдээлэл ачаалахад алдаа гарлаа",

        // filters
        "filter.title": "Шүүлтүүр",
        "filter.totalRows": "Нийт мөр",
        "filter.search": "Sender / Beneficiary / Банк",
        "filter.dateFrom": "Эхлэх",
        "filter.dateTo": "Дуусах",

        // table columns
        "col.id": "ID",
        "col.sender": "Sender",
        "col.beneficiary": "Beneficiary",
        "col.beneficiaryBank": "Bene Bank",
        "col.currency": "Валют",
        "col.amount": "Дүн",
        "col.name": "Нэр",
        "col.rate": "Ханш",
        "col.institution": "Байгууллага",
        "col.executedDate": "Огноо",
        "col.executionDate": "Гүйлгээний огноо",
        "col.invoice": "Нэхэмжлэл",
        "col.receipt": "Баримт",
        "col.status": "Төлөв",
        "col.row": "Мөр",
        "col.errors": "Алдаа",
        "col.actions": "Үйлдэл",

        // values
        "invoice.none": "Нэхэмжлэл байхгүй",
        "invoice.has": "Нэхэмжлэлтэй",
        "invoice.hasNot": "Нэхэмжлэлгүй",

        // invoice modal
        "invoice.modalTitle": "Нэхэмжлэл харах",
        "invoice.file": "Файл",
        "invoice.size": "Хэмжээ",
        "invoice.uploaded": "Хавсаргасан",
        "invoice.loading": "Нэхэмжлэл ачааллаж байна...",
        "invoice.empty": "Нэхэмжлэл байхгүй байна",
        "invoice.error": "Нэхэмжлэлийн алдаа",
        "invoice.loadFailed": "Нэхэмжлэлийг ачаалж чадсангүй",
        "invoice.downloaded": "Нэхэмжлэл татагдлаа",
        "invoice.downloadFailed": "Нэхэмжлэл татахад алдаа гарлаа",
        "invoice.uploadFailed": "Нэхэмжлэл хавсаргахад алдаа гарлаа",
        "invoice.uploaded.ok": "Нэхэмжлэл хавсаргагдлаа",
        "invoice.replaced.ok": "Нэхэмжлэл солигдлоо",
        "invoice.noPermission": "Нэхэмжлэл хавсаргах эрх танд байхгүй байна",
        "invoice.delete": "Нэхэмжлэл устгах",
        "invoice.deleteConfirmTitle": "Нэхэмжлэлийг устгах уу?",
        "invoice.deleteConfirmBody": "Мэдээлэл хэвээр үлдэж, зөвхөн хавсаргасан PDF файл устгагдана.",
        "invoice.deleted": "Нэхэмжлэл амжилттай устгагдлаа",
        "invoice.deleteFailed": "Нэхэмжлэлийг устгаж чадсангүй",

        // edit / delete (admin)
        "edit.modalTitle": "Гүйлгээний төлөвлөгөө засах",
        "edit.hint": "Мөрийн мэдээллийг засна. unq_id өөрчлөгдөхгүй.",
        "edit.saved": "Гүйлгээний төлөвлөгөө шинэчлэгдлээ",
        "edit.saveFailed": "Засварыг хадгалахад алдаа гарлаа",
        "edit.saveError": "Засварын алдаа",
        "delete.confirmTitle": "Энэ мөрийг устгах уу?",
        "delete.confirmBody": "Устгасан мөр болон түүний Нэхэмжлэлийг сэргээх боломжгүй.",
        "delete.done": "Гүйлгээний төлөвлөгөө устгагдлаа",
        "delete.failed": "Устгахад алдаа гарлаа",
        "delete.noPermission": "Устгах эрхгүй байна",

        // add modal
        "add.modalTitle": "Гүйлгээний төлөвлөгөө нэмэх",
        "add.tab.excel": "Excel импорт",
        "add.tab.manual": "Гараар нэмэх",

        // excel import
        "excel.title": "Excel файл оруулах",
        "excel.columns":
            "Багана: № | Sender | Beneficiary | Bene Bank | Currency / Валюта | Amount / Сумма | Execution date / Дата исполнения",
        "excel.drop": "Excel файлаа энд чирж оруулах эсвэл дарж сонгоно уу",
        "excel.hint": "Upload хийсний дараа мөр бүрийн шалгалтын үр дүн preview дээр харагдана",
        "excel.noFile": "Файл сонгоогүй",
        "excel.reading": "Уншиж байна...",
        "excel.importable": "Импортлох",
        "excel.duplicate": "Давхардсан",
        "excel.duplicateHint": "импортлогдоно",
        "excel.invalid": "Алдаатай",
        "excel.previewTitle": "Excel мөрүүдийг шалгах",
        "excel.confirm": "Би мөрүүдийг шалгасан, импортлож болно",
        "excel.import": "Импортлох",
        "excel.file": "Файл",
        "excel.totalRows": "Нийт мөр",
        "excel.ready": "Импортлох боломжтой мөрүүд бэлэн",
        "excel.notReady": "Импортлох боломжтой мөр алга",
        "excel.fileError": "Файлын алдаа",
        "excel.error": "Excel алдаа",
        "excel.readFailed": "Excel уншихад алдаа гарлаа",
        "excel.importFailed": "Импорт амжилтгүй боллоо",
        "excel.importOk": "Импорт амжилттай",
        "excel.selectFile": "Excel файл сонгоно уу",
        "excel.nothingToImport": "Импортлох боломжтой мөр алга байна",
        "excel.confirmFirst": "Мөрүүдийг шалгаснаа баталгаажуулна уу",
        "excel.noRows": "Мөр олдсонгүй",
        "excel.status.ok": "Импортлох боломжтой",
        "excel.status.dupFile": "Файл дотроо давхардсан (импортлоно)",
        "excel.status.dupDb": "Өмнө бүртгэгдсэн (импортлоно)",
        "excel.status.invalid": "Алдаатай",

        // manual form
        "manual.title": "Гараар нэмэх",
        "manual.hint": "Excel-тэй ижил бүтэцтэй. unq_id нь мөрийн агуулгаас автоматаар үүснэ.",
        "manual.saved": "Гүйлгээний төлөвлөгөө хадгалагдлаа",
        "manual.saveFailed": "Хадгалахад алдаа гарлаа",
        "manual.saveError": "Хадгалах алдаа",
        "manual.ph.sender": "Илгээгч байгууллага",
        "manual.ph.beneficiary": "Хүлээн авагч байгууллага",
        "manual.ph.beneficiaryBank": "Хүлээн авагчийн банк",
        "manual.ph.date": "Огноо сонгох",
        "req.sender": "Sender заавал бөглөнө",
        "req.beneficiary": "Beneficiary заавал бөглөнө",
        "req.currency": "Валют заавал сонгоно",
        "req.amount": "Дүн заавал бөглөнө",
        "req.amountPositive": "Дүн 0-ээс их байх ёстой",
        "req.date": "Огноо заавал сонгоно",
        "req.max50": "50 тэмдэгтээс их байж болохгүй",
        "req.max255": "255 тэмдэгтээс их байж болохгүй",

        // rates (Ханш)
        "rate.title": "Ханш",
        "rate.stat.total": "Нийт ханш",
        "rate.stat.filtered": "Шүүлтээр олдсон",
        "rate.empty": "Ханш олдсонгүй",
        "rate.loadError": "Ханш ачаалахад алдаа гарлаа",
        "rate.filter.search": "Нэр / Валют / Байгууллага",

        "rate.add.modalTitle": "Ханш нэмэх",
        "rate.excel.columns":
            "Багана: № | Name | Currency | Institution | Amount | Executed date | Rate. Institution болон Executed date заавал биш.",

        "rate.manual.title": "Гараар нэмэх",
        "rate.manual.hint": "Excel-тэй ижил бүтэцтэй. Байгууллага, огноо заавал биш.",
        "rate.manual.saved": "Ханш хадгалагдлаа",
        "rate.manual.saveFailed": "Ханш хадгалахад алдаа гарлаа",
        "rate.manual.ph.name": "Байгууллагын нэр",
        "rate.manual.ph.institution": "AMT / SFG / STU / ATM",

        "rate.edit.modalTitle": "Ханш засах",
        "rate.edit.hint": "Мөрийн мэдээллийг засна.",
        "rate.edit.saved": "Ханш шинэчлэгдлээ",
        "rate.edit.saveFailed": "Засварыг хадгалахад алдаа гарлаа",

        "rate.delete.confirmBody": "Устгасан ханшийг сэргээх боломжгүй.",
        "rate.delete.done": "Ханш устгагдлаа",
        "rate.delete.failed": "Ханш устгахад алдаа гарлаа",

        "rate.req.name": "Нэр заавал бөглөнө",
        "rate.req.rate": "Ханш заавал бөглөнө",
        "rate.req.ratePositive": "Ханш 0-ээс их байх ёстой",
        "rate.req.max100": "100 тэмдэгтээс их байж болохгүй",

        // bulk selection / mass delete
        "bulk.selected": "мөр сонгогдсон",
        "bulk.withInvoice": "Сонгосон мөрүүдийн нэхэмжлэлтэй тоо",
        "bulk.withReceipt": "Сонгосон мөрүүдийн баримттай тоо",
        "bulk.clear": "Сонголт цуцлах",
        "bulk.confirmTitle": "Сонгосон мөрүүдийг устгах уу?",
        "bulk.confirmBody": "Сонгосон бүх мөр болон хавсаргасан нэхэмжлэл устана. Буцаах боломжгүй.",
        "bulk.receipt.confirmBody": "Сонгосон бүх мөр болон хавсаргасан PDF баримт устана. Буцаах боломжгүй.",
        "bulk.deleted": "Устгасан",
        "bulk.alreadyGone": "Өмнө нь устсан",
        "bulk.deleteFailed": "Бөөнөөр устгахад алдаа гарлаа",

        // transaction receipts (Гүйлгээний Баримт)
        "receipt.title": "Гүйлгээний Баримт",
        "receipt.stat.total": "Нийт баримт",
        "receipt.stat.withReceipt": "PDF хавсаргасан",
        "receipt.stat.filtered": "Шүүлтээр олдсон",
        "receipt.empty": "Гүйлгээний баримт олдсонгүй",
        "receipt.loadError": "Гүйлгээний баримт ачаалахад алдаа гарлаа",
        "receipt.filter.search": "Нэр / Валют / Байгууллага",

        "receipt.none": "Баримт байхгүй",
        "receipt.has": "Баримттай",
        "receipt.hasNot": "Баримтгүй",
        "receipt.upload": "Баримт",

        "receipt.modalTitle": "Гүйлгээний баримт харах",
        "receipt.loading": "Баримт ачааллаж байна...",
        "receipt.empty.file": "Баримт байхгүй байна",
        "receipt.error": "Баримтын алдаа",
        "receipt.loadFailed": "Баримтыг ачаалж чадсангүй",
        "receipt.downloaded": "Баримт татагдлаа",
        "receipt.downloadFailed": "Баримт татахад алдаа гарлаа",
        "receipt.uploadFailed": "Баримт хавсаргахад алдаа гарлаа",
        "receipt.uploaded.ok": "Баримт хавсаргагдлаа",
        "receipt.replaced.ok": "Баримт солигдлоо",
        "receipt.noPermission": "Баримт хавсаргах эрх танд байхгүй байна",
        "receipt.delete": "Баримт устгах",
        "receipt.deleteConfirmTitle": "Баримтыг устгах уу?",
        "receipt.deleteConfirmBody": "Мөр хэвээр үлдэж, зөвхөн хавсаргасан PDF файл устгагдана.",
        "receipt.deleted": "Баримт амжилттай устгагдлаа",
        "receipt.deleteFailed": "Баримтыг устгаж чадсангүй",

        "receipt.add.modalTitle": "Гүйлгээний баримт нэмэх",
        "receipt.excel.columns":
            "Багана: № | Нэр | Валют | Байгууллага | Дүн | Огноо | Ханш. Байгууллага, огноо, ханш заавал биш. Файлын Нийт үнийн дүн багана байвал уншихгүй.",
        "receipt.rateOptional": "Заавал биш.",
        "receipt.rateOptionalPh": "0.0000 (заавал биш)",

        // temporary initial-data import screen
        "initial.title": "Анхны дата оруулах",
        "initial.subtitle": "Гүйлгээний баримтын анхны өгөгдлийг нэг дор ачаалах түр дэлгэц. Эхлээд Excel-ээ импортлоод, дараа нь PDF баримтуудын ZIP-ийг хавсаргана.",
        "initial.temporary": "Түр зориулалттай дэлгэц",
        "initial.temporaryHint": "Анхны өгөгдөл ороод дуусмагц энэ цэсийг устгана. Өдөр тутмын ажилд Гүйлгээний Баримт хуудсыг ашиглана.",
        "initial.step1": "1-р алхам: Excel импорт",
        "initial.step2": "2-р алхам: PDF баримтуудын ZIP",
        "initial.step1Hint": "111.xlsx мэтийн нэг файлыг оруулна. Мөрүүд эхлээд үүсэх ёстой - PDF нь зөвхөн байгаа мөрд хавсрана.",
        "initial.zip.title": "PDF баримтуудыг бөөнөөр хавсаргах",
        "initial.zip.hint": "ZIP доторх PDF бүр нэрээрээ мөртэй тулгагдана: <Байгууллага>_<Дүн>_<Огноо>.pdf, жишээ нь LLC_MERA_15780000.00_2026-01-22.pdf",
        "initial.zip.drop": "ZIP файлаа энд чирж оруулна уу",
        "initial.zip.selectFile": "ZIP файл сонгоно уу",
        "initial.zip.reading": "ZIP уншиж байна...",
        "initial.zip.previewTitle": "ZIP-ийн урьдчилсан харагдац",
        "initial.zip.matched": "Хавсаргах боломжтой",
        "initial.zip.hasReceipt": "Баримттай мөр",
        "initial.zip.notFound": "Мөр олдоогүй",
        "initial.zip.ambiguous": "Тодорхойгүй",
        "initial.zip.invalid": "Алдаатай",
        "initial.zip.replaceExisting": "Баримттай мөрийн PDF-ийг солих",
        "initial.zip.replaceHint": "Тэмдэглээгүй бол баримт хавсаргасан мөрүүд хэвээр үлдэнэ.",
        "initial.zip.confirm": "Урьдчилсан харагдацыг шалгаж, хавсаргахыг зөвшөөрч байна",
        "initial.zip.attach": "Хавсаргах",
        "initial.zip.nothingToAttach": "Хавсаргах файл алга",
        "initial.zip.importOk": "PDF хавсаргалт дууслаа",
        "initial.zip.importFailed": "PDF хавсаргахад алдаа гарлаа",
        "initial.zip.file": "Файл",
        "initial.zip.noFile": "Файл сонгоогүй",
        "initial.zip.col.file": "PDF файл",
        "initial.zip.col.parsed": "Нэрнээс уншсан",
        "initial.zip.col.matched": "Тулгасан мөр",
        "initial.zip.col.score": "Нэрний оноо",
        "initial.zip.col.message": "Тайлбар",

        "receipt.manual.title": "Гараар нэмэх",
        "receipt.manual.hint": "Excel-тэй ижил бүтэцтэй. PDF баримтыг хадгалсны дараа жагсаалтаас хавсаргана.",
        "receipt.manual.saved": "Гүйлгээний баримт хадгалагдлаа",
        "receipt.manual.saveFailed": "Гүйлгээний баримт хадгалахад алдаа гарлаа",
        "receipt.manual.ph.name": "Байгууллагын нэр",
        "receipt.manual.ph.institution": "AMT / SFG / STU / ATM",

        "receipt.edit.modalTitle": "Гүйлгээний баримт засах",
        "receipt.edit.hint": "Мөрийн мэдээллийг засна. Хавсаргасан PDF өөрчлөгдөхгүй.",
        "receipt.edit.saved": "Гүйлгээний баримт шинэчлэгдлээ",
        "receipt.edit.saveFailed": "Засварыг хадгалахад алдаа гарлаа",

        "receipt.delete.confirmBody": "Устгасан мөр болон түүний PDF баримтыг сэргээх боломжгүй.",
        "receipt.delete.done": "Гүйлгээний баримт устгагдлаа",
        "receipt.delete.failed": "Гүйлгээний баримт устгахад алдаа гарлаа",

        "receipt.req.name": "Нэр заавал бөглөнө",
        "receipt.req.ratePositive": "Ханш 0-ээс их байх ёстой",
        "receipt.req.max100": "100 тэмдэгтээс их байж болохгүй",

        // login
        "login.title": "SFG системд нэвтрэх",
        "login.username": "Нэвтрэх нэр",
        "login.password": "Нууц үг",
        "login.submit": "Нэвтрэх",
        "login.failed": "Нэвтрэхэд алдаа гарлаа",
    },

    en: {
        "lang.name": "English",
        "lang.switch": "Language",

        "app.title": "STU Finance",
        "nav.transactionPlan": "Transaction Plan",
        "nav.transactionReceipt": "Transaction Receipts",
        "nav.transactionSchedule": "Transaction Schedule",
        "nav.balance": "Balance",
        "nav.statements": "Statements",
        "nav.institutions": "Institutions",
        "nav.rates": "Rates",
        "nav.users": "Users",
        "nav.logout": "Sign out",

        "action.refresh": "Refresh",
        "action.add": "Add data",
        "action.save": "Save",
        "action.clear": "Clear",
        "action.close": "Close",
        "action.download": "Download",
        "action.view": "View",
        "action.upload": "Invoice",
        "action.replace": "Replace",
        "action.preview": "Preview",
        "action.removeFile": "Remove file",
        "action.retry": "Try again",
        "action.edit": "Edit",
        "action.delete": "Delete",
        "action.cancel": "Cancel",

        "plan.title": "Transaction Plan",
        "plan.stat.total": "Total plans",
        "plan.stat.withInvoice": "With invoice",
        "plan.stat.filtered": "Matching filter",
        "plan.empty": "No transaction plans found",
        "plan.loadError": "Failed to load the data",

        "filter.title": "Filters",
        "filter.totalRows": "Total rows",
        "filter.search": "Sender / Beneficiary / Bank",
        "filter.dateFrom": "From",
        "filter.dateTo": "To",

        "col.id": "ID",
        "col.sender": "Sender",
        "col.beneficiary": "Beneficiary",
        "col.beneficiaryBank": "Bene Bank",
        "col.currency": "Currency",
        "col.amount": "Amount",
        "col.name": "Name",
        "col.rate": "Rate",
        "col.institution": "Institution",
        "col.executedDate": "Executed date",
        "col.executionDate": "Transaction date",
        "col.invoice": "Invoice",
        "col.receipt": "Receipt",
        "col.status": "Status",
        "col.row": "Row",
        "col.errors": "Errors",
        "col.actions": "Actions",

        "invoice.none": "No invoice",
        "invoice.has": "With invoice",
        "invoice.hasNot": "Without invoice",

        "invoice.modalTitle": "View invoice",
        "invoice.file": "File",
        "invoice.size": "Size",
        "invoice.uploaded": "Uploaded",
        "invoice.loading": "Loading the invoice...",
        "invoice.empty": "No invoice attached",
        "invoice.error": "Invoice error",
        "invoice.loadFailed": "Could not load the invoice",
        "invoice.downloaded": "Invoice downloaded",
        "invoice.downloadFailed": "Failed to download the invoice",
        "invoice.uploadFailed": "Failed to attach the invoice",
        "invoice.uploaded.ok": "Invoice attached",
        "invoice.replaced.ok": "Invoice replaced",
        "invoice.noPermission": "You are not allowed to attach invoices",
        "invoice.delete": "Delete invoice",
        "invoice.deleteConfirmTitle": "Delete this invoice?",
        "invoice.deleteConfirmBody": "The row stays; only the attached PDF is removed.",
        "invoice.deleted": "Invoice deleted",
        "invoice.deleteFailed": "Failed to delete the invoice",

        "edit.modalTitle": "Edit transaction plan",
        "edit.hint": "Update the row's details. The unq_id stays unchanged.",
        "edit.saved": "Transaction plan updated",
        "edit.saveFailed": "Failed to save the changes",
        "edit.saveError": "Update error",
        "delete.confirmTitle": "Delete this row?",
        "delete.confirmBody": "The row and its invoice cannot be recovered.",
        "delete.done": "Transaction plan deleted",
        "delete.failed": "Failed to delete",
        "delete.noPermission": "You are not allowed to delete",

        "add.modalTitle": "Add a transaction plan",
        "add.tab.excel": "Excel import",
        "add.tab.manual": "Manual entry",

        "excel.title": "Upload an Excel file",
        "excel.columns":
            "Columns: № | Sender | Beneficiary | Bene Bank | Currency / Валюта | Amount / Сумма | Execution date / Дата исполнения",
        "excel.drop": "Drag an Excel file here, or click to choose one",
        "excel.hint": "After uploading, every parsed row is shown with its validation result",
        "excel.noFile": "No file selected",
        "excel.reading": "Reading...",
        "excel.importable": "Importable",
        "excel.duplicate": "Duplicates",
        "excel.duplicateHint": "imported anyway",
        "excel.invalid": "Invalid",
        "excel.previewTitle": "Review the Excel rows",
        "excel.confirm": "I have reviewed the rows and they can be imported",
        "excel.import": "Import",
        "excel.file": "File",
        "excel.totalRows": "Total rows",
        "excel.ready": "Rows are ready to import",
        "excel.notReady": "Nothing can be imported",
        "excel.fileError": "File errors",
        "excel.error": "Excel error",
        "excel.readFailed": "Failed to read the Excel file",
        "excel.importFailed": "Import failed",
        "excel.importOk": "Import finished",
        "excel.selectFile": "Choose an Excel file",
        "excel.nothingToImport": "There are no importable rows",
        "excel.confirmFirst": "Please confirm you reviewed the rows",
        "excel.noRows": "No rows found",
        "excel.status.ok": "Importable",
        "excel.status.dupFile": "Duplicate in file (still imported)",
        "excel.status.dupDb": "Already in database (still imported)",
        "excel.status.invalid": "Invalid",

        "manual.title": "Manual entry",
        "manual.hint":
            "Same structure as the Excel file. The unq_id is generated from the row content.",
        "manual.saved": "Transaction plan saved",
        "manual.saveFailed": "Failed to save",
        "manual.saveError": "Save error",
        "manual.ph.sender": "Sending company",
        "manual.ph.beneficiary": "Receiving company",
        "manual.ph.beneficiaryBank": "Beneficiary bank",
        "manual.ph.date": "Pick a date",
        "req.sender": "Sender is required",
        "req.beneficiary": "Beneficiary is required",
        "req.currency": "Currency is required",
        "req.amount": "Amount is required",
        "req.amountPositive": "Amount must be greater than 0",
        "req.date": "Date is required",
        "req.max50": "Must be at most 50 characters",
        "req.max255": "Must be at most 255 characters",

        "rate.title": "Rates",
        "rate.stat.total": "Total rates",
        "rate.stat.filtered": "Matching filter",
        "rate.empty": "No rates found",
        "rate.loadError": "Failed to load the rates",
        "rate.filter.search": "Name / Currency / Institution",

        "rate.add.modalTitle": "Add a rate",
        "rate.excel.columns":
            "Columns: \u2116 | Name | Currency | Institution | Amount | Executed date | Rate. Institution and Executed date are optional.",

        "rate.manual.title": "Manual entry",
        "rate.manual.hint": "Same structure as the Excel file. Institution and date are optional.",
        "rate.manual.saved": "Rate saved",
        "rate.manual.saveFailed": "Failed to save the rate",
        "rate.manual.ph.name": "Company name",
        "rate.manual.ph.institution": "AMT / SFG / STU / ATM",

        "rate.edit.modalTitle": "Edit rate",
        "rate.edit.hint": "Update the row's details.",
        "rate.edit.saved": "Rate updated",
        "rate.edit.saveFailed": "Failed to save the changes",

        "rate.delete.confirmBody": "A deleted rate cannot be recovered.",
        "rate.delete.done": "Rate deleted",
        "rate.delete.failed": "Failed to delete the rate",

        "rate.req.name": "Name is required",
        "rate.req.rate": "Rate is required",
        "rate.req.ratePositive": "Rate must be greater than 0",
        "rate.req.max100": "Must be at most 100 characters",

        // bulk selection / mass delete
        "bulk.selected": "rows selected",
        "bulk.withInvoice": "How many of the selected rows have an invoice",
        "bulk.withReceipt": "How many of the selected rows have a receipt",
        "bulk.clear": "Clear selection",
        "bulk.confirmTitle": "Delete the selected rows?",
        "bulk.confirmBody": "Every selected row and its attached invoice will be deleted. This cannot be undone.",
        "bulk.receipt.confirmBody": "Every selected row and its attached PDF receipt will be deleted. This cannot be undone.",
        "bulk.deleted": "Deleted",
        "bulk.alreadyGone": "Already gone",
        "bulk.deleteFailed": "Failed to delete the selected rows",

        // transaction receipts
        "receipt.title": "Transaction Receipts",
        "receipt.stat.total": "Total records",
        "receipt.stat.withReceipt": "With PDF",
        "receipt.stat.filtered": "Matching filter",
        "receipt.empty": "No transaction receipts found",
        "receipt.loadError": "Failed to load the transaction receipts",
        "receipt.filter.search": "Name / Currency / Institution",

        "receipt.none": "No receipt",
        "receipt.has": "With receipt",
        "receipt.hasNot": "Without receipt",
        "receipt.upload": "Receipt",

        "receipt.modalTitle": "View receipt",
        "receipt.loading": "Loading the receipt...",
        "receipt.empty.file": "No receipt attached",
        "receipt.error": "Receipt error",
        "receipt.loadFailed": "Could not load the receipt",
        "receipt.downloaded": "Receipt downloaded",
        "receipt.downloadFailed": "Failed to download the receipt",
        "receipt.uploadFailed": "Failed to attach the receipt",
        "receipt.uploaded.ok": "Receipt attached",
        "receipt.replaced.ok": "Receipt replaced",
        "receipt.noPermission": "You are not allowed to attach receipts",
        "receipt.delete": "Delete receipt",
        "receipt.deleteConfirmTitle": "Delete this receipt?",
        "receipt.deleteConfirmBody": "The row stays; only the attached PDF is removed.",
        "receipt.deleted": "Receipt deleted",
        "receipt.deleteFailed": "Failed to delete the receipt",

        "receipt.add.modalTitle": "Add a transaction receipt",
        "receipt.excel.columns":
            "Columns: No | Name | Currency | Institution | Amount | Date | Rate. Institution, date and rate are optional. A Total amount column in the file is ignored.",
        "receipt.rateOptional": "Optional.",
        "receipt.rateOptionalPh": "0.0000 (optional)",

        "initial.title": "Initial data import",
        "initial.subtitle": "Temporary screen for loading the first batch of transaction receipt data. Import the Excel file first, then attach the ZIP of receipt PDFs.",
        "initial.temporary": "Temporary screen",
        "initial.temporaryHint": "Remove this menu entry once the initial data is loaded. Use the Transaction Receipts page for day to day work.",
        "initial.step1": "Step 1: Excel import",
        "initial.step2": "Step 2: ZIP of receipt PDFs",
        "initial.step1Hint": "Upload one workbook such as 111.xlsx. The rows have to exist first - a PDF is only ever attached to an existing row.",
        "initial.zip.title": "Attach receipt PDFs in bulk",
        "initial.zip.hint": "Every PDF in the ZIP is matched to a row by its file name: <Organization>_<Amount>_<Date>.pdf, for example LLC_MERA_15780000.00_2026-01-22.pdf",
        "initial.zip.drop": "Drop the ZIP file here",
        "initial.zip.selectFile": "Select a ZIP file",
        "initial.zip.reading": "Reading the ZIP...",
        "initial.zip.previewTitle": "ZIP preview",
        "initial.zip.matched": "Ready to attach",
        "initial.zip.hasReceipt": "Row already has a receipt",
        "initial.zip.notFound": "No matching row",
        "initial.zip.ambiguous": "Ambiguous",
        "initial.zip.invalid": "Invalid",
        "initial.zip.replaceExisting": "Replace the PDF on rows that already have one",
        "initial.zip.replaceHint": "Left unchecked, rows that already carry a receipt are kept as they are.",
        "initial.zip.confirm": "I have reviewed the preview and want to attach these PDFs",
        "initial.zip.attach": "Attach",
        "initial.zip.nothingToAttach": "Nothing to attach",
        "initial.zip.importOk": "PDF attachment finished",
        "initial.zip.importFailed": "Failed to attach the PDFs",
        "initial.zip.file": "File",
        "initial.zip.noFile": "No file selected",
        "initial.zip.col.file": "PDF file",
        "initial.zip.col.parsed": "Read from the name",
        "initial.zip.col.matched": "Matched row",
        "initial.zip.col.score": "Name score",
        "initial.zip.col.message": "Detail",

        "receipt.manual.title": "Manual entry",
        "receipt.manual.hint": "Same structure as the Excel file. The total amount is derived automatically. Attach the PDF from the list once the row is saved.",
        "receipt.manual.saved": "Transaction receipt saved",
        "receipt.manual.saveFailed": "Failed to save the transaction receipt",
        "receipt.manual.ph.name": "Company name",
        "receipt.manual.ph.institution": "AMT / SFG / STU / ATM",

        "receipt.edit.modalTitle": "Edit transaction receipt",
        "receipt.edit.hint": "Update the row's details. The attached PDF stays unchanged.",
        "receipt.edit.saved": "Transaction receipt updated",
        "receipt.edit.saveFailed": "Failed to save the changes",

        "receipt.delete.confirmBody": "The row and its PDF receipt cannot be restored.",
        "receipt.delete.done": "Transaction receipt deleted",
        "receipt.delete.failed": "Failed to delete the transaction receipt",

        "receipt.req.name": "Name is required",
        "receipt.req.ratePositive": "The rate must be greater than 0",
        "receipt.req.max100": "Must not exceed 100 characters",

        "login.title": "SFG system login",
        "login.username": "Username",
        "login.password": "Password",
        "login.submit": "Sign in",
        "login.failed": "Login failed",
    },
};

export default translations;
